import { FC } from 'react';

interface Props {
  value: number;
  currencyCode: string;
}

type CurrencySettings = {
  significantDigits: number;
  thousandsSeparator: string;
  decimalSeparator: string;
  symbol: string;
};

const supportCurrencies: { [key: string]: CurrencySettings } = {
  USD: {
    significantDigits: 2,
    thousandsSeparator: ',',
    decimalSeparator: '.',
    symbol: '$',
  },
};

const Currency: FC<Props> = ({ value, currencyCode }) => {
  const settings = supportCurrencies[currencyCode];

  if (!settings) {
    return <>{value}</>;
  }

  const formattedValue = value.toFixed(settings.significantDigits);
  const [currency, decimal] = formattedValue.split('.');

  return (
    <>
      {settings.symbol}
      {currency.replace(/\B(?=(\d{3})+(?!\d))/g, settings.thousandsSeparator)}
      {settings.decimalSeparator}
      {decimal}
    </>
  );
};

export default Currency;
